// extracted by mini-css-extract-plugin
export var cardborder = "StandardSignPostCard-module--cardborder--c6822";
export var cardbordercontainer = "StandardSignPostCard-module--cardbordercontainer--3e502";
export var cardcontainer = "StandardSignPostCard-module--cardcontainer--4e8db";
export var cardcontainersquare = "StandardSignPostCard-module--cardcontainersquare--b8141";
export var cardcta = "StandardSignPostCard-module--cardcta--fe061";
export var carddetails = "StandardSignPostCard-module--carddetails--f3497";
export var cardimage = "StandardSignPostCard-module--cardimage--1eecb";
export var cardimagecontainer = "StandardSignPostCard-module--cardimagecontainer--812c9";
export var cardtext = "StandardSignPostCard-module--cardtext--978e4";
export var cardtitle = "StandardSignPostCard-module--cardtitle--2201a";
export var date = "StandardSignPostCard-module--date--a30c2";
export var verticalcardborder = "StandardSignPostCard-module--verticalcardborder--f3064";